// Libs
import styled, { css } from 'styled-components'

// Comps
import { Section } from '../Section'
import { H6 } from '../H6'
import { H1 } from '../H1'
import { CTA } from '../CTA'
import { show } from '../../utils'

// Defs
interface Props {
  smallHeader?: string | React.ReactNode
  largeHeader?: string | React.ReactNode
  bgImage?: string
  bgColor?: string
  ctaText?: string
  showCTA?: boolean
  ctaClassNames?: string
  onCtaClick?: () => any
  showScrollDown?: boolean
  maxWidth?: number
  unlockedWidth?: boolean
  maxDynamicPadding?: number
  underChild?: React.ReactNode
}

// Styles
import { bowedHeroSectionStyles } from './bowedHeroSectionStyles'

const Container = styled(Section)<Props>`
  ${bowedHeroSectionStyles}
`

export const BowedHeroSection: React.FC<Props> = (props) => {
  // Props
  const {
    smallHeader,
    largeHeader,
    ctaText,
    showCTA,
    onCtaClick,
    bgImage,
    ctaClassNames,
    showScrollDown = true,
    maxWidth = 1300,
    unlockedWidth = false,
    maxDynamicPadding = 197,
    bgColor,
    underChild,
  } = props

  // Funcs
  const onClick = () => {
    if (onCtaClick) {
      onCtaClick()
    } else {
      console.warn('@BowedHero->onCtaClick not set')
    }
  }

  // ..
  return (
    <Container
      className="BowedHero"
      unlockWidthConstraint
      bgImage={bgImage}
      maxWidth={maxWidth}
      bgColor={bgColor}
      maxDynamicPadding={maxDynamicPadding}
      unlockedWidth={unlockedWidth}>
      {/* Full screen width background */}
      <div className="background">
        {/* {show(bgImage !== null && bgImage !== undefined) && <> */}
        <div className="bg-image" />
        {/* </>} */}
      </div>

      {/* Background with bow */}
      <div className="content-container">
        <div className="heroText">
          {show(smallHeader !== null && smallHeader !== undefined) && (
            <>
              <H6 className="heroSmallHeader">{smallHeader || ''}</H6>
            </>
          )}
          {show(largeHeader !== null && largeHeader !== undefined) && (
            <>
              <H1 className="heroHeader">{largeHeader || ''}</H1>
            </>
          )}
          {show(showCTA === true) && (
            <CTA className={ctaClassNames || ''} onClick={onClick}>
              {ctaText || 'empty CTA'}
            </CTA>
          )}

          {underChild || null}
        </div>

        {/* Hide scroll down tip when you CTA is active */}
        {show(showCTA !== true && showScrollDown === true) && (
          <div className="icon-container">
            <div className="heroIconArrow">
              <span className="icon-arrow"></span>
            </div>
          </div>
        )}
      </div>
    </Container>
  )
}
